/**
 * API Error Prototype abstracting realtime returned response error
 */
import { clone, compose, isEmpty, not } from '~/utils/lib/core/prelude'

/**
 * API Error Constructor
 * @constructor
 * @param {string} cause
 * @param {string} message
 * @param {any} [payload]
 * @extends {Error}
 */
// @ts-ignore: JSDoc ES5 Prototype Constructor handling
function APIError(cause, message, payload = undefined) {
  // @ts-ignore: typing false negative, as <Error> can bear optional second argument
  const instance = new Error(message, { cause })

  if (compose(not, isEmpty)(payload))
    // @ts-ignore: quick extension of <Error> not handled by typing definition
    instance.payload = clone(payload)

  Object.setPrototypeOf(instance, Object.getPrototypeOf(this))

  return instance
}

APIError.prototype = Object.create(Error.prototype, {
  constructor: {
    value: Error,
    enumerable: false,
    writable: true,
    configurable: true
  }
})

export default APIError

